import dayjs from "dayjs";
import Actions from "../actions";
import { produce } from "immer";

const initialState = {
  serviceProviderCustomers: {},
  selectedAppointmentDate: {},
  serviceProviderAppointments: [],
  serviceProviderAppointmentsInfo: {},
  selectedServiceProviderAppointmentId: "",
  selectedAppointmentsInfoId: "",
  selectedCalendarAppointment:{
    selectedCalendarAppointmentId: "",
    service_id:"",
    order_type:""
  },
  selectedServiceIdForPackage:"",
  selectedAppointmentOrderType:"",
  selectedAppointmentPackageServiceId:""
};

const serviceProviderAppointments = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_SERVICE_PROVIDER_APPOINTMENTS_LIST: {
      const tempServiceProviderAppointments =
        payload?.serviceProviderAppointments?.data?.map((element) => {
          const appointment_end_time = new Date(
            element?.appointment_date_time
          ).setMinutes(
            new Date(element?.appointment_date_time).getMinutes() + 30
          );

          return {
            service_id:element?.service_id,
            _id: element?._id,
            title: `${element?.booking_for_details?.first_name}`,
            date: dayjs(element?.appointment_date).format("YYYY-MM-DD") || "",
            start:
              // dayjs(element?.appointment_date_time)
              //   .subtract(
              //     dayjs(element?.appointment_date_time).utcOffset(),
              //     "minute"
              //   )
              //   .format("YYYY-MM-DDTHH:mm:ss") || "",
                dayjs(element?.appointment_date_time).utc().local().format("YYYY-MM-DDTHH:mm:ss") || "",
            end: 
            // dayjs(appointment_end_time)
            //   .subtract(dayjs(appointment_end_time).utcOffset(), "minute")
            //   .format("YYYY-MM-DDTHH:mm:ss"),
            dayjs(appointment_end_time).utc().local().format("YYYY-MM-DDTHH:mm:ss") || ""
          };
        });
      draft.serviceProviderAppointments = tempServiceProviderAppointments;

      draft.serviceProviderAppointmentsInfo =
        payload?.serviceProviderAppointments;
      break;
    }

    case Actions.SELECTED_APPOINTMENT_DATE: {
      draft.selectedAppointmentDate = payload?.selectedAppointmentDate;
      break;
    }

    case Actions.SELECTED_CALENDAR_APPOINTMENT_ID: {
      draft.selectedCalendarAppointment = payload?.selectedCalendarAppointment;
      break;
    }

    case Actions.SELECTED_APPOINTMENTS_INFO_ID: {
      draft.selectedAppointmentsInfoId = payload?.selectedAppointmentsInfoId;
      break;
    }

    case Actions.SELECTED_APPOINTMENT_ORDER_TYPE: {
      draft.selectedAppointmentOrderType = payload?.selectedAppointmentOrderType;
      break;
    }
    case Actions.SELECTED_APPOINTMENT_PACKAGE_SERVICE_ID: {
      draft.selectedAppointmentPackageServiceId = payload?.selectedAppointmentPackageServiceId;
      break;
    }

    case Actions.SELECTED_SERVICE_ID_FOR_PACKAGE: {
      draft.selectedServiceIdForPackage = payload?.selectedServiceIdForPackage;
      break;
    }

    case Actions.SELECTED_SERVICE_PROVIDER_APPOINTMENT_ID: {
      draft.selectedServiceProviderAppointmentId =
        payload?.selectedServiceProviderAppointmentId;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default serviceProviderAppointments;
